import {faBars} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {ComponentType, useRef, useState} from 'react'
import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import Row from 'react-bootstrap/Row';
import {useTranslation} from "react-i18next";
import {Outlet} from "react-router-dom";
import {LogoutForm} from "../auth/LogoutForm";
import {AccessibleSpinner} from "../common/AccessibleSpinner";
import {useAuthenticatedUserContext} from "../hook/UseAuthenticatedUserContext";
import {useSpinnerStatusContext} from "../hook/UseSpinnerStatusContext";
import './AppLayout.scss'
import '../styles/Styles.scss'
import {Utils} from "../utils/Utils";

interface AdminLayoutProps {
    AppSidebar : ComponentType<{
        className?: string;
    }>
    Menu? : ComponentType<{
        className?: string;
    }>
}

interface MobileSideBarProps {
    AppSidebar : ComponentType<{
        className?: string;
    }>
}

// mobile sidebar which is show off canvas
function MobileSideBar({AppSidebar} : Readonly<MobileSideBarProps>)
{
    const [show, setShow] = useState(false);

    return (
        <>
            <Button variant="primary" className="d-lg-none" onClick={() => setShow(true)}>
                <FontAwesomeIcon icon={faBars} size="xl"/>
            </Button>

            <Offcanvas show={show} onHide={() => setShow(false)}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>CipherMail</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <AppSidebar />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}

/**
 * Represents the main layout of authenticated page.
 */
export const AppLayout = ({AppSidebar, Menu} : AdminLayoutProps) =>
{
    const {authenticatedUser, clearAuthenticatedUser} = useAuthenticatedUserContext();
    const {spinnerStateCounter} = useSpinnerStatusContext();
    /**
     * A reference to the invisible logout submit button which can be used to programmatically submit
     * the logout form when the user selects logout from the menu
     */
    const logoutSubmitButtonRef = useRef<HTMLButtonElement>(null);
    /**
     * i18next translation hook
     */
    const {t} = useTranslation('components');

    return (
        <div className="container-fluid d-flex flex-column vh-100">
            <Row className="flex-grow-1 min-height-0">
                <div className="sidebar border border-right col-2 d-flex flex-column h-100 overflow-auto d-none d-lg-block">
                    <div className="navbar-brand d-none d-lg-block mb-3 mt-3">
                        <img src={Utils.createPublicHostResourceUrl("layout-logo")}
                             width="150" alt="CipherMail Logo" className="me-3"/>
                    </div>

                    {<AppSidebar/>}
                </div>

                <main className="col-md-12 col-lg-10 d-flex flex-column h-100 bg-body-tertiary">
                    
                    <Row id="header"/>

                    <Row>
                        <nav className="navbar navbar-expand border-bottom">
                            <MobileSideBar AppSidebar={AppSidebar}/>

                            <AccessibleSpinner show={spinnerStateCounter > 0} className="ms-3"/>

                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="ms-auto z-index-popover">
                                    <NavDropdown title={authenticatedUser}>
                                        {Menu !== undefined && <Menu/>}
                                        <NavDropdown.Item onClick={() => {
                                            clearAuthenticatedUser();
                                            logoutSubmitButtonRef.current?.click()
                                        }}>
                                            {t("login.logout")}
                                        </NavDropdown.Item>
                                    </NavDropdown>
                                </Nav>
                            </Navbar.Collapse>
                        </nav>
                    </Row>

                    {/* The child "pages" will be added here*/}
                    <Outlet/>
                </main>
            </Row>

            <LogoutForm ref={logoutSubmitButtonRef}/>
        </div>
    );
}
